import React from "react"
import styled from 'styled-components'
import {Link} from "react-router-dom"
import {LogoMobile} from 'components/static/icons'

const LogoWrapper = styled.div`
  display: block;
  height: 60px;

  @media screen and (max-width: 767px) {
    order: 1;
    height: 50px;
    margin-bottom: 20px
  }
`;

const LogotypeWrapper = styled.div`
  display: flex;
  height: 60px;
  justify-content: flex-start;
  flex-wrap: nowrap;
  padding-left: 30px;
  user-select: none;
  pointer-events: none;

  @media screen and (max-width: 767px) {
    justify-content: space-between;
    padding-left: 15px;
  }
`;

const LogotypeText = styled.div`
  width: 40px;
  margin-right: 5px;
  font-family: 'Roboto Condensed', 'Helvetica Condensed', 'Helvetica Neue', Helvetica, sans-serif;
  font-weight: 300;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  font-size: 18px;
  color: #333;
  text-transform: uppercase;
  line-height: 21px;

  @media screen and (max-width: 767px) {
    width: auto;
    margin-right: 0;
    order: 2;
  }
`;

const Logotype = () => {
  return (
    <Link style={{textDecoration:'none'}} to='/'>
      <LogotypeWrapper>
        <LogotypeText>By The Bay</LogotypeText>
        <LogoWrapper><LogoMobile/></LogoWrapper>
      </LogotypeWrapper>
    </Link>
  )
}

export default Logotype



// WEBPACK FOOTER //
// ./src/layout/logotype.js